import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Role } from 'src/app/core/constants/role.enum';
import { UserStore } from 'src/app/core/stores/user.store';

@Injectable({
  providedIn: 'root',
})
export class ScheduledRoundCreateGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly userStore = inject(UserStore);

  canActivate(): boolean | UrlTree {
    const role = this.userStore.userRole() ?? this.userStore.user().role;

    if (role === Role.NON_USER) {
      return this.router.parseUrl('/scheduled-rounds');
    }

    return true;
  }
}
